import { Component } from '@angular/core';
import { RevealDirective } from '../../core/directives/reveal.directive';

interface FaqItem {
  q: string;
  a: string;
}

@Component({
  selector: 'hx-faq',
  standalone: true,
  imports: [RevealDirective],
  template: `
    <section class="section-tight">
      <div class="wrap">
        <div class="section-head reveal" appReveal>
          <p class="eyebrow">Questions</p>
          <h2>Referral FAQ</h2>
        </div>
        <div class="reveal" appReveal>
          @for (item of faqs; track item.q) {
            <div class="faq-item">
              <h4>{{ item.q }}</h4>
              <p>{{ item.a }}</p>
            </div>
          }
        </div>
      </div>
    </section>
  `,
})
export class FaqComponent {
  faqs: FaqItem[] = [
    {
      q: 'When do I get paid?',
      a: 'It depends on the project type. For complex custom builds ("We Earn, You Earn"), you\'re paid in stages alongside the client\'s own payments — starting with their first. For hosted/subscription projects ("You Earn, We\'re Discovered"), you\'re paid once, after the project is deployed and accepted.',
    },
    {
      q: 'How do I know which program my referral falls under?',
      a: "You don't need to figure this out yourself — once we scope the referred project, our team will tell you which program applies and what your commission looks like.",
    },
    {
      q: 'Is there a limit to how many businesses I can refer?',
      a: 'No — every successful referral qualifies for a reward, regardless of how many you send.',
    },
    {
      q: 'Can I refer a business I already work with?',
      a: "Yes, as long as they aren't already an active Hexacorp client or in conversation with us.",
    },
  ];
}
